import type React from 'react'
import {createContext, use} from 'react'

import type {DeferredData} from '../types/commits-types'

export const baseEmptyStateLoading: DeferredData = {
  deferredCommits: [],
  renameHistory: null,
  loading: true,
}

export const baseEmptyStateNotLoading: DeferredData = {
  deferredCommits: [],
  renameHistory: null,
  loading: false,
}

const DeferredCommitDataContext = createContext<DeferredData>(baseEmptyStateLoading)

export function DeferredCommitDataProvider({
  children,
  deferredData,
}: React.PropsWithChildren<{deferredData: DeferredData}>) {
  return <DeferredCommitDataContext value={deferredData}>{children}</DeferredCommitDataContext>
}

export function useFindDeferredCommitData(oid: string) {
  const deferredData = use(DeferredCommitDataContext)

  const isError = deferredData.error
  //this will never be null in the actual execution of the code, but having the '?' makes testing everything
  //significantly easier.
  let commitDataForOid = deferredData.deferredCommits?.find(data => data?.oid === oid)
  if (isError && commitDataForOid === undefined) {
    commitDataForOid = {oid, statusCheckStatus: undefined}
  }
  return commitDataForOid
}

export function useIsDeferredDataLoading() {
  const deferredData = use(DeferredCommitDataContext)
  return deferredData.loading
}

export function useRenameHistoryData() {
  const deferredData = use(DeferredCommitDataContext)

  return deferredData.renameHistory
}

try{ DeferredCommitDataContext.displayName ||= 'DeferredCommitDataContext' } catch {}
try{ DeferredCommitDataProvider.displayName ||= 'DeferredCommitDataProvider' } catch {}